import { render, staticRenderFns } from "./FormBusinessTermsComponent.vue?vue&type=template&id=268d90e1&lang=pug"
import script from "./FormBusinessTermsComponent.vue?vue&type=script&lang=js"
export * from "./FormBusinessTermsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('268d90e1')) {
      api.createRecord('268d90e1', component.options)
    } else {
      api.reload('268d90e1', component.options)
    }
    module.hot.accept("./FormBusinessTermsComponent.vue?vue&type=template&id=268d90e1&lang=pug", function () {
      api.rerender('268d90e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/business_terms/components/FormBusinessTermsComponent.vue"
export default component.exports